import { render, staticRenderFns } from "./TopicOnHomepage.vue?vue&type=template&id=e5131b1a&scoped=true&"
import script from "./TopicOnHomepage.vue?vue&type=script&lang=js&"
export * from "./TopicOnHomepage.vue?vue&type=script&lang=js&"
import style0 from "./TopicOnHomepage.vue?vue&type=style&index=0&id=e5131b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5131b1a",
  null
  
)

export default component.exports